import React, { FC } from 'react'
import { SVGProps } from './types'

export const RewardCoin: FC<SVGProps> = ({ size = 24, color, onClick }) => {
  const strokeColor = color ?? '#E5B93C'
  const fillColor = color ?? '#FFF2BF'

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      onClick={onClick}
    >
      <circle
        cx={12}
        cy={12}
        r={9}
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={1.5}
      />
      <circle cx={12} cy={12} r={6.5} stroke={strokeColor} strokeWidth={1} />
      <path
        d="M12 7.5L13.6 10.7L17 11.2L14.5 13.6L15.1 17L12 15.3L8.9 17L9.5 13.6L7 11.2L10.4 10.7L12 7.5Z"
        fill={strokeColor}
      />
    </svg>
  )
}
